import { defineStore, acceptHMRUpdate } from "pinia";
import Api from "../utils/api";

export const usePreDefinedListStore = defineStore("pre_defined_list_store", {
  persist: true,
  state: () => ({
    preDefinedFullList: []
  }),
  actions: {
    async getPreDefinedListData(config, customTableName = null) {
      let _res = await Api.PreDefinedList.getPreDefinedLists(
        config,
        customTableName
      );
      if (customTableName) {
        return _res;
      }
      this.preDefinedFullList = _res.data || [];
      return _res;
    },
    async getPreDefinedListById(id) {
      if (this.preDefinedFullList.length === 0) {
        await this.getPreDefinedListData({ fetchAll: true });
      }
      let _res = this.preDefinedFullList.find((item) => item.id === id) || null;
      let _records = [];
      if (_res) {
        _records = _res.list;
      }
      return _records;
    },
    async newPreDefinedListItem(listId, record) {
      // Find the list in the store
      const existingList = this.preDefinedFullList.find(
        (item) => item.id === listId
      );
      if (!existingList) {
        throw new Error("List not found");
      }

      // Create new records array with added record
      const updatedRecords = [...existingList.list, record];

      // Update store
      existingList.list = updatedRecords;

      // Update database
      const { error } = await Api.PreDefinedList.updatePreDefinedList({
        id: listId,
        list: updatedRecords
      });

      if (error) {
        console.error("Failed to add new item to pre-defined list:", error);
        throw error;
      }
    },
    async updatePreDefinedListItem(listId, record) {
      // Find the list in the store
      const existingList = this.preDefinedFullList.find(
        (item) => item.id === listId
      );
      if (!existingList) {
        throw new Error("List not found");
      }

      // Create new records array with added record
      const updatedRecords = existingList.list.map((item) =>
        item.id === record.id ? record : item
      );

      // Update store
      existingList.list = updatedRecords;

      // Update database
      const { error } = await Api.PreDefinedList.updatePreDefinedList({
        id: listId,
        list: updatedRecords
      });

      if (error) {
        console.error("Failed to update item in pre-defined list:", error);
        throw error;
      }
    },
    async deletePreDefinedListItem(listId, recordId) {
      // Find the list in the store
      const existingList = this.preDefinedFullList.find(
        (item) => item.id === listId
      );
      if (!existingList) {
        throw new Error("List not found");
      }

      // Create new records array with added record
      const updatedRecords = existingList.list.filter(
        (item) => item.id !== recordId
      );

      // Update store
      existingList.list = updatedRecords;

      // Update database
      const { error } = await Api.PreDefinedList.updatePreDefinedList({
        id: listId,
        list: updatedRecords
      });

      if (error) {
        console.error("Failed to delete item from pre-defined list:", error);
        throw error;
      }
    }
  },
  $reset() {
    this.preDefinedFullList = [];
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(usePreDefinedListStore, import.meta.hot)
  );
}
